"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var vue_property_decorator_1 = require("vue-property-decorator");
var vue_codemirror_1 = require("vue-codemirror");
require("codemirror/lib/codemirror.css");
require("codemirror/addon/fold/foldgutter.css");
require("codemirror/addon/lint/lint.css");
require("codemirror/mode/javascript/javascript");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/edit/closebrackets");
require("codemirror/addon/fold/foldcode");
require("codemirror/addon/fold/foldgutter");
require("codemirror/addon/fold/brace-fold");
require("codemirror/addon/lint/lint");
require("codemirror/addon/lint/json-lint");
var jsonlint_mod_1 = require("jsonlint-mod");
window.jsonlint = jsonlint_mod_1.default;
var PLACEHOLDER_RE = /\{\{\s*([\w]+)\s*\}\}/g;
function placeholderStyle(expression, known) {
    var trimmed = expression.trim();
    if (/^[A-Za-z_]\w*\s*\(/.test(trimmed)) {
        return 'placeholder-function';
    }
    var name = trimmed.split('|')[0].trim();
    if (!/^[A-Za-z_]\w*$/.test(name)) {
        return 'placeholder-expression';
    }
    return known.has(name) ? 'placeholder-known' : 'placeholder-unknown';
}
function formatCsvTemplate(text) {
    return text
        .split('\n')
        .map(function (line) { return line.trim(); })
        .filter(function (line) { return line !== ''; })
        .join('\n');
}
var PRIMARY_PLACEHOLDER_NAMES = new Set([
    'email',
    'firstname',
    'lastname',
    'civility',
    'birthday',
    'zipcode',
    'city',
    'address',
    'phone',
    'country',
    'first_phones_unchecked',
    'collect_date'
]);
var COMPLEX_PREFIX = 'complex_';
var CONSENT_FUNCTION_PREFIX = "{{ has_consent('phone', ";
var CONSENT_FUNCTION_ADVERTISER_ID = '0';
var CONSENT_FUNCTION_SUFFIX = ') ? 1 : 0 }}';
var CONSENT_FUNCTION_EXAMPLE = "{{ has_consent('phone', 1234) ? 1 : 0 }}";
var CONSENT_STATE_FUNCTIONS = [
    { name: 'consent_status', snippet: "{{ consent_status('phone', 1234) }}" },
    {
        name: 'consent_granted_at',
        snippet: "{{ consent_granted_at('phone', 1234, 'd/m/Y') }}"
    },
    {
        name: 'consent_expires_at',
        snippet: "{{ consent_expires_at('phone', 1234, 'd/m/Y') }}"
    },
    {
        name: 'consent_withdrawn_at',
        snippet: "{{ consent_withdrawn_at('phone', 1234, 'd/m/Y') }}"
    }
];
var COMMON_HEADERS = [
    'Accept: application/json',
    'Accept: application/x-www-form-urlencoded',
    'Accept: text/xml',
    'Content-Type: application/json',
    'Content-Type: application/x-www-form-urlencoded',
    'Content-Type: text/xml',
    'Authorization: Bearer ',
    'Authorization: Basic ',
    'Cache-Control: no-cache'
];
var PLACEHOLDER_EXAMPLES = {
    email: 'john.doe@example.com',
    cookieUid: 'a1b2c3d4-e5f6-7890',
    ip: '203.0.113.42',
    firstname: 'John',
    lastname: 'Doe',
    civility: 'Mr',
    birthday: '1980-01-15',
    zipcode: '75001',
    city: 'Paris',
    address: '12 rue de Rivoli',
    phone: '+33612345678',
    country: 'FR',
    referer: 'https://example.com/landing'
};
var JsonEditorComponent = (function (_super) {
    __extends(JsonEditorComponent, _super);
    function JsonEditorComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cmInstance = null;
        _this.overlay = null;
        _this.headerOverlay = null;
        _this.cursorPlaced = false;
        _this.showAll = false;
        _this.bodyFormat = 'json';
        _this.commonHeaders = COMMON_HEADERS;
        _this.consentStateFunctions = CONSENT_STATE_FUNCTIONS;
        _this.consentFunctionExample = CONSENT_FUNCTION_EXAMPLE;
        _this.cmOptions = {
            mode: 'application/json',
            lineNumbers: true,
            tabSize: 2,
            indentUnit: 2,
            smartIndent: true,
            matchBrackets: true,
            autoCloseBrackets: true,
            foldGutter: true,
            gutters: [
                'CodeMirror-linenumbers',
                'CodeMirror-foldgutter',
                'CodeMirror-lint-markers'
            ],
            lint: false,
            viewportMargin: Infinity
        };
        return _this;
    }
    Object.defineProperty(JsonEditorComponent.prototype, "innerValue", {
        get: function () {
            return this.value || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "hasError", {
        get: function () {
            var e = this.errorMessages;
            return Array.isArray(e) ? e.length > 0 : !!e;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "firstError", {
        get: function () {
            var e = this.errorMessages;
            return Array.isArray(e) ? e[0] || '' : e;
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorComponent.prototype.isPrimary = function (code) {
        return (PRIMARY_PLACEHOLDER_NAMES.has(code) || code.startsWith(COMPLEX_PREFIX));
    };
    Object.defineProperty(JsonEditorComponent.prototype, "primaryPlaceholders", {
        get: function () {
            var _this = this;
            return this.placeholders.filter(function (p) { return _this.isPrimary(p); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "secondaryPlaceholders", {
        get: function () {
            var _this = this;
            return this.placeholders.filter(function (p) { return !_this.isPrimary(p); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "visibleChips", {
        get: function () {
            return this.showAll
                ? __spread(this.primaryPlaceholders, this.secondaryPlaceholders) : this.primaryPlaceholders;
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorComponent.prototype.parseJsonWithPlaceholders = function (text) {
        if (!text.trim()) {
            return null;
        }
        var stripped = text.replace(/\{\{[^}]*\}\}/g, function (match) {
            return match.replace(/[^\n]/g, 'x');
        });
        try {
            JSON.parse(stripped);
            return null;
        }
        catch (e) {
            var message = String(e.message || 'Invalid JSON');
            var posMatch = message.match(/position\s+(\d+)/i);
            var line = 1;
            if (posMatch) {
                var pos = parseInt(posMatch[1], 10);
                line = stripped.substring(0, pos).split('\n').length;
            }
            return { line: line, message: message };
        }
    };
    Object.defineProperty(JsonEditorComponent.prototype, "effectiveValidateJson", {
        get: function () {
            if (this.enableFormatToggle) {
                return this.bodyFormat === 'json';
            }
            return this.validateJson;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "jsonError", {
        get: function () {
            if (!this.effectiveValidateJson) {
                return null;
            }
            return this.parseJsonWithPlaceholders(this.innerValue);
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorComponent.prototype.lintJson = function (text) {
        var err = this.parseJsonWithPlaceholders(text);
        if (!err) {
            return [];
        }
        var lineIndex = err.line - 1;
        var lineText = text.split('\n')[lineIndex] || '';
        return [
            {
                from: { line: lineIndex, ch: 0 },
                to: { line: lineIndex, ch: lineText.length },
                message: err.message,
                severity: 'error'
            }
        ];
    };
    Object.defineProperty(JsonEditorComponent.prototype, "canPrettify", {
        get: function () {
            if (this.csvTemplate) {
                return formatCsvTemplate(this.innerValue) !== this.innerValue;
            }
            var raw = this.innerValue.trim();
            if (!raw) {
                return false;
            }
            try {
                JSON.parse(raw);
                return true;
            }
            catch (_) {
                return false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JsonEditorComponent.prototype, "unknownPlaceholders", {
        get: function () {
            if (!this.placeholders.length) {
                return [];
            }
            var known = new Set(this.placeholders);
            var found = new Set();
            var m;
            PLACEHOLDER_RE.lastIndex = 0;
            while ((m = PLACEHOLDER_RE.exec(this.innerValue)) !== null) {
                if (!known.has(m[1])) {
                    found.add(m[1]);
                }
            }
            return Array.from(found);
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorComponent.prototype.exampleFor = function (code) {
        var tKey = "campaign_factory.form.json_editor.example." + code;
        var translated = this.$te(tKey) ? this.$t(tKey) : '';
        if (translated) {
            return translated;
        }
        if (PLACEHOLDER_EXAMPLES[code]) {
            return PLACEHOLDER_EXAMPLES[code];
        }
        return this.$t('campaign_factory.form.json_editor.example_unavailable');
    };
    JsonEditorComponent.prototype.onInput = function (newValue) {
        this.$emit('input', newValue);
    };
    JsonEditorComponent.prototype.onBlur = function () {
        this.$emit('change', this.innerValue);
    };
    JsonEditorComponent.prototype.onCmReady = function (cm) {
        var _this = this;
        this.cmInstance = cm;
        cm.on('focus', function () {
            _this.cursorPlaced = true;
        });
        this.refreshOverlay();
        this.refreshHeaderOverlay();
        this.applyLintOption();
    };
    JsonEditorComponent.prototype.refreshHeaderOverlay = function () {
        if (!this.cmInstance) {
            return;
        }
        if (this.headerOverlay) {
            this.cmInstance.removeOverlay(this.headerOverlay);
            this.headerOverlay = null;
        }
        if (!this.showHeaderSuggestions) {
            return;
        }
        this.headerOverlay = {
            startState: function () { return ({ inValue: false }); },
            token: function (stream, state) {
                if (stream.sol()) {
                    state.inValue = false;
                    if (stream.string.indexOf(':') === -1) {
                        stream.skipToEnd();
                        return null;
                    }
                }
                if (state.inValue) {
                    stream.skipToEnd();
                    return 'header-value';
                }
                if (stream.peek() === ':') {
                    stream.next();
                    state.inValue = true;
                    return 'header-separator';
                }
                stream.next();
                return 'header-key';
            }
        };
        this.cmInstance.addOverlay(this.headerOverlay);
    };
    JsonEditorComponent.prototype.onPlaceholdersChange = function () {
        this.refreshOverlay();
    };
    JsonEditorComponent.prototype.onValidateJsonChange = function () {
        this.applyLintOption();
    };
    JsonEditorComponent.prototype.onBodyFormatChange = function () {
        this.applyLintOption();
    };
    JsonEditorComponent.prototype.mounted = function () {
        if (this.enableFormatToggle &&
            this.innerValue.trim() !== '' &&
            this.parseJsonWithPlaceholders(this.innerValue) !== null) {
            this.bodyFormat = 'urlencoded';
        }
    };
    JsonEditorComponent.prototype.setBodyFormat = function (format) {
        if (!format || format === this.bodyFormat) {
            return;
        }
        var converted = format === 'urlencoded'
            ? this.convertJsonToUrlencoded(this.innerValue)
            : this.convertUrlencodedToJson(this.innerValue);
        this.bodyFormat = format;
        this.$emit('input', converted);
        this.$emit('change', converted);
    };
    JsonEditorComponent.prototype.convertJsonToUrlencoded = function (text) {
        var raw = text.trim();
        if (raw === '') {
            return text;
        }
        var parsed;
        try {
            parsed = JSON.parse(raw);
        }
        catch (_) {
            return text;
        }
        if (typeof parsed !== 'object' ||
            parsed === null ||
            Array.isArray(parsed)) {
            return text;
        }
        return Object.entries(parsed)
            .map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
            return key + "=" + stringValue;
        })
            .join('&');
    };
    JsonEditorComponent.prototype.convertUrlencodedToJson = function (text) {
        var raw = text.trim();
        if (raw === '') {
            return text;
        }
        var result = {};
        raw.split('&').forEach(function (pair) {
            if (pair === '') {
                return;
            }
            var separatorIndex = pair.indexOf('=');
            var key = separatorIndex === -1 ? pair : pair.substring(0, separatorIndex);
            var value = separatorIndex === -1 ? '' : pair.substring(separatorIndex + 1);
            result[key.trim()] = value;
        });
        return JSON.stringify(result, null, 2);
    };
    JsonEditorComponent.prototype.insertHeaderLine = function (headerLine) {
        var ref = this.$refs.cm;
        if (!ref || !ref.codemirror) {
            return;
        }
        var cm = ref.codemirror;
        cm.focus();
        var headerName = headerLine.split(':')[0].trim().toLowerCase();
        var lineCount = cm.lineCount();
        for (var line = 0; line < lineCount; line++) {
            var lineText = cm.getLine(line) || '';
            var separatorIndex = lineText.indexOf(':');
            if (separatorIndex === -1) {
                continue;
            }
            var existingName = lineText
                .substring(0, separatorIndex)
                .trim()
                .toLowerCase();
            if (existingName === headerName) {
                cm.replaceRange(headerLine, { line: line, ch: 0 }, { line: line, ch: lineText.length });
                return;
            }
        }
        var doc = cm.getDoc();
        var cursor = doc.getCursor();
        var currentLine = cm.getLine(cursor.line) || '';
        var needsLeadingNewline = currentLine.trim() !== '';
        doc.replaceSelection((needsLeadingNewline ? '\n' : '') + headerLine + '\n');
    };
    JsonEditorComponent.prototype.applyLintOption = function () {
        var _this = this;
        if (!this.cmInstance) {
            return;
        }
        var lintConfig = this.effectiveValidateJson
            ? { getAnnotations: function (text) { return _this.lintJson(text); } }
            : false;
        this.cmInstance.setOption('lint', lintConfig);
    };
    JsonEditorComponent.prototype.refreshOverlay = function () {
        if (!this.cmInstance) {
            return;
        }
        if (this.overlay) {
            this.cmInstance.removeOverlay(this.overlay);
        }
        var known = new Set(this.placeholders);
        this.overlay = {
            token: function (stream) {
                if (stream.match('{{')) {
                    var buffer = '';
                    var ch = void 0;
                    while ((ch = stream.next()) != null) {
                        if (ch === '}' && stream.peek() === '}') {
                            stream.next();
                            return placeholderStyle(buffer, known);
                        }
                        buffer += ch;
                    }
                    return 'placeholder-unknown';
                }
                while (stream.next() != null && !stream.match('{{', false)) {
                }
                return null;
            }
        };
        this.cmInstance.addOverlay(this.overlay);
    };
    JsonEditorComponent.prototype.insertSnippet = function (snippet) {
        var ref = this.$refs.cm;
        if (!ref || !ref.codemirror) {
            return null;
        }
        var cm = ref.codemirror;
        var doc = cm.getDoc();
        var cursorPlaced = this.cursorPlaced;
        cm.focus();
        if (!this.csvTemplate) {
            var start_1 = doc.indexFromPos(doc.getCursor('from'));
            doc.replaceSelection(snippet);
            return start_1;
        }
        var line = cursorPlaced ? doc.getCursor('to').line : doc.lastLine();
        var lineText = doc.getLine(line) || '';
        var lineEnd = { line: line, ch: lineText.length };
        var prefix = lineText.trim() === '' ? '' : '\n';
        var start = doc.indexFromPos(lineEnd) + prefix.length;
        doc.replaceRange(prefix + snippet, lineEnd);
        doc.setCursor(doc.posFromIndex(start + snippet.length));
        this.cursorPlaced = true;
        return start;
    };
    JsonEditorComponent.prototype.insertConsentFunction = function () {
        var start = this.insertSnippet(CONSENT_FUNCTION_PREFIX +
            CONSENT_FUNCTION_ADVERTISER_ID +
            CONSENT_FUNCTION_SUFFIX);
        if (start === null) {
            return;
        }
        var doc = this.$refs.cm.codemirror.getDoc();
        var idStart = start + CONSENT_FUNCTION_PREFIX.length;
        doc.setSelection(doc.posFromIndex(idStart), doc.posFromIndex(idStart + CONSENT_FUNCTION_ADVERTISER_ID.length));
    };
    JsonEditorComponent.prototype.insertEmptyPair = function () {
        var ref = this.$refs.cm;
        if (!ref || !ref.codemirror) {
            return;
        }
        var cm = ref.codemirror;
        var text = cm.getValue();
        if (!text.trim()) {
            var snippet_1 = '{\n  "": ""\n}';
            cm.setValue(snippet_1);
            cm.focus();
            cm.setCursor({ line: 1, ch: 3 });
            return;
        }
        var closingIndex = text.lastIndexOf('}');
        var insertOffset = closingIndex !== -1 ? closingIndex : text.length;
        while (insertOffset > 0 && /\s/.test(text[insertOffset - 1])) {
            insertOffset--;
        }
        var prev = insertOffset > 0 ? text[insertOffset - 1] : '';
        var needsCommaBefore = prev !== '' && prev !== '{' && prev !== '[' && prev !== ',';
        var closingLine = closingIndex !== -1
            ? cm.posFromIndex(closingIndex).line
            : cm.posFromIndex(insertOffset).line;
        var closingLineText = cm.getLine(closingLine) || '';
        var baseIndentMatch = closingLineText.match(/^(\s*)/);
        var baseIndent = baseIndentMatch ? baseIndentMatch[1] : '';
        var indent = baseIndent + '  ';
        var snippet = (needsCommaBefore ? ',' : '') + '\n' + indent + '"": ""';
        var insertPos = cm.posFromIndex(insertOffset);
        cm.focus();
        cm.replaceRange(snippet, insertPos);
        var firstQuoteOffset = snippet.indexOf('"');
        cm.setCursor(cm.posFromIndex(insertOffset + firstQuoteOffset + 1));
    };
    JsonEditorComponent.prototype.prettify = function () {
        var raw = this.innerValue;
        if (this.csvTemplate) {
            var formatted = formatCsvTemplate(raw);
            this.$emit('input', formatted);
            this.$emit('change', formatted);
            return;
        }
        try {
            var formatted = JSON.stringify(JSON.parse(raw), null, 2);
            this.$emit('input', formatted);
            this.$emit('change', formatted);
        }
        catch (_) {
        }
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: '' }),
        __metadata("design:type", String)
    ], JsonEditorComponent.prototype, "value", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: function () { return []; } }),
        __metadata("design:type", Array)
    ], JsonEditorComponent.prototype, "placeholders", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' }),
        __metadata("design:type", String)
    ], JsonEditorComponent.prototype, "label", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' }),
        __metadata("design:type", String)
    ], JsonEditorComponent.prototype, "hint", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: function () { return []; } }),
        __metadata("design:type", Object)
    ], JsonEditorComponent.prototype, "errorMessages", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: '' }),
        __metadata("design:type", String)
    ], JsonEditorComponent.prototype, "name", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "required", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "validateJson", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "enableFormatToggle", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "showHeaderSuggestions", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "showConsentFunction", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], JsonEditorComponent.prototype, "csvTemplate", void 0);
    __decorate([
        vue_property_decorator_1.Watch('placeholders'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], JsonEditorComponent.prototype, "onPlaceholdersChange", null);
    __decorate([
        vue_property_decorator_1.Watch('validateJson'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], JsonEditorComponent.prototype, "onValidateJsonChange", null);
    __decorate([
        vue_property_decorator_1.Watch('bodyFormat'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], JsonEditorComponent.prototype, "onBodyFormatChange", null);
    JsonEditorComponent = __decorate([
        vue_class_component_1.default({ components: { codemirror: vue_codemirror_1.codemirror } })
    ], JsonEditorComponent);
    return JsonEditorComponent;
}(vue_1.default));
exports.default = JsonEditorComponent;
